export default "__VITE_ASSET__CuVW4H8i__"